// extracted by mini-css-extract-plugin
export default {"buttonContainer":"JoinUs_buttonContainer__lTOqw","hero":"JoinUs_hero__rNZjB"};